/**
 * Step 1 do NewTenantWizard — Identificação (TASK-2435).
 *
 * Coleta:
 *   - project_name (UPPERCASE, regex ^[A-Z][A-Z0-9]+$, 2-30 chars)
 *   - cost_center (opcional, texto livre)
 *
 * O input é auto-uppercase no onChange e mostra erro inline se o regex falhar.
 */

import { Stack, TextInput, Text, Alert } from '@mantine/core'
import { IconInfoCircle } from '@tabler/icons-react'
import {
  PROJECT_NAME_REGEX,
  type TenantSpec,
} from '@/api/awsOrgProvisioning'

interface WizardStepIdentificacaoProps {
  spec: TenantSpec
  onChange: (spec: TenantSpec) => void
}

export function WizardStepIdentificacao({
  spec,
  onChange,
}: WizardStepIdentificacaoProps) {
  const projectName = spec.project_name
  const projectNameTouched = projectName.length > 0
  const projectNameError =
    projectNameTouched && !PROJECT_NAME_REGEX.test(projectName)
      ? 'Use apenas LETRAS MAIÚSCULAS e dígitos, comece com letra (ex.: GETNET, MDM2).'
      : null

  return (
    <Stack gap="md" mt="md">
      <Alert
        variant="light"
        color="blue"
        icon={<IconInfoCircle size={18} />}
        title="Convenção de nomes"
      >
        <Text size="sm">
          Use o nome curto, em CAIXA ALTA, do projeto/cliente. Ele será aplicado
          ao OU em AWS Organizations, à OU de ambientes (DEV/QA/HML/PRD), aos
          IAM users, secrets e tags. <b>Não use hífens, underscores ou espaços.</b>
        </Text>
      </Alert>

      <TextInput
        label="Nome do projeto"
        description="2-30 caracteres, somente A-Z e 0-9, começando por letra."
        placeholder="GETNET"
        required
        value={projectName}
        error={projectNameError}
        onChange={(e) =>
          onChange({
            ...spec,
            project_name: e.currentTarget.value.toUpperCase(),
          })
        }
        data-testid="wizard-project-name"
      />

      <TextInput
        label="Centro de custo (opcional)"
        description="Aparece como tag CostCenter em todos os recursos AWS criados."
        placeholder="CC-1234"
        value={spec.cost_center ?? ''}
        onChange={(e) =>
          onChange({
            ...spec,
            cost_center: e.currentTarget.value || null,
          })
        }
        data-testid="wizard-cost-center"
      />
    </Stack>
  )
}
